export const JOB_ADS_FO_ALGOLIA_INDEX_FROM_UNLEASH = "algolia_index_permanent_ab_test"

export const JOB_ADS_FO_SAVED_SEARCHES = "saved_searches"
export const JOB_ADS_FO_SAVED_SEARCHES_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOB_ADS_FO_ALGOLIA_DEBUG = "algolia_debug"

export const JOB_ADS_CONTENT_BOOST = "content_boost_job_offers"

export const JOB_ADS_FO_SEEN_CARD = "job_ads_seen_card"
export const JOB_ADS_FO_SEEN_CARD_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOB_ADS_FO_SAVED_SEARCH_NEW_JOB_ADS_SINCE_LAST_SEEN = "saved_search_new_job_ads_since_last_seen"
export const JOB_ADS_FO_SAVED_SEARCH_NEW_JOB_ADS_SINCE_LAST_SEEN_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE = "saved_search_on_mobile"
export const JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOBS_WITH_IMPACT = "jobs_with_impact"
export const JOBS_WITH_IMPACT_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOB_ADS_FO_WOOSMAP_MIGRATION = "job_ads_fo_woosmap_migration"

export const KEYWORD_SUGGESTION = "keyword_suggestion"
export const KEYWORD_SUGGESTION_VARIANTS = { DISABLED: "feature_off", ENABLED: "feature_on" }

export const JOB_ADS_FO_PUBLICATION_DATE_FILTER = "publication_date_filter"
export const JOB_ADS_FO_PUBLICATION_DATE_FILTER_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}
